import { Site } from './site';

export class ControlPoint {
  controlPointId!: number;
  siteId!: number;
  numeroPoint!: number;
  name!: string;
  description!: string;
  site!: Site;
  x!: number;
  y!: number;
  z!: number;
  ppv!: number;
  k!: number;
  alpha!: number;
}
